const steps = [
  {
    num: '01',
    title: '创建家庭',
    desc: '注册账号，创建家庭，邀请家庭成员加入，设置各成员权限。',
    icon: 'ri-home-heart-fill',
    color: 'from-blue-500 to-indigo-600'
  },
  {
    num: '02',
    title: '制定规则',
    desc: '根据孩子的情况，设定奖惩规则、习惯目标及积分商城奖励清单。',
    icon: 'ri-list-check-3',
    color: 'from-purple-500 to-pink-500'
  },
  {
    num: '03',
    title: '记录执行',
    desc: '通过APP或语音告知AI，自动识别并记录孩子的积分变动。',
    icon: 'ri-record-circle-fill',
    color: 'from-amber-400 to-orange-500'
  },
  {
    num: '04',
    title: '习惯养成',
    desc: '通过数据分析追踪进度，科学评估习惯养成效果，持续优化机制。',
    icon: 'ri-seedling-fill',
    color: 'from-green-500 to-teal-500'
  }
];

export default function HowItWorksSection() {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-br from-[#f0f4ff] to-[#e8f0fe]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white text-[#1a56db] text-sm px-4 py-2 rounded-full mb-4 font-medium">
              <i className="ri-route-fill"></i>
              <span>使用流程</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-[#0d2d6e] mb-4">简单四步<br />开启成长之旅</h2>
            <p className="text-gray-500 text-lg mb-10 max-w-md mx-auto lg:mx-0">无需复杂配置，几分钟上手，让习惯养成变得科学、有趣、可量化。</p>
            <div className="grid grid-cols-3 gap-4 text-center">
              {[
                { val: '10,000+', label: '活跃家庭' },
                { val: '50万+', label: '习惯记录' },
                { val: '3.2亿', label: '积分发放' }
              ].map(s => (
                <div key={s.label} className="bg-white rounded-2xl p-4">
                  <div className="text-2xl font-black bg-gradient-to-r from-[#1a56db] to-[#0d2d6e] bg-clip-text text-transparent">{s.val}</div>
                  <div className="text-gray-400 text-xs mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {steps.map((step, i) => (
                <div key={i} className="bg-white rounded-2xl p-6 group hover:-translate-y-1 transition-all duration-300" style={{boxShadow:'0 2px 16px rgba(26,86,219,0.08)'}}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-r ${step.color}`}>
                      <i className={`${step.icon} text-white text-lg`}></i>
                    </div>
                    <span className="text-3xl font-black text-gray-100">{step.num}</span>
                  </div>
                  <h3 className="font-bold text-[#0d2d6e] text-base mb-2">{step.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
